import React, { memo } from 'react'

import { Icon } from '../index'
import { util } from '../../../util'
import PropTypes from 'prop-types'

const ToastMessage = ({ show, message }) => {
    if (!show) {
        return null
    }
    return (
        <div className={'toast_msg'}>
            <Icon size={'xs'} className={'circle_icon'} renderIcon={util.CheckCircleIcon} />
            <p className={'msg'}>{message}</p>
        </div>
    )
}

ToastMessage.prototypes = {
    /**@param message {String} -> message to be displayed inside toast message */
    message: PropTypes.String,
    show: PropTypes.bool,
}

export default memo(ToastMessage)
